import React from 'react';
import { cn } from '@/lib/utils';
import { ComplianceLinks } from '@/components/ComplianceLinks';
import smile from '@/assets/images/report/footer/smile-white.svg';
import { useReportI18n } from '@/pages/reports/i18n';

export const Footer: React.FC = () => {
  const { t } = useReportI18n();

  return (
    <section className={cn('w-full bg-[#F2FF00]')}>
      <div className="container mx-auto">
        <div className="w-full max-w-[500px] mx-auto py-10 md:py-14 px-6 md:px-0">
          <div className="flex flex-col gap-8 text-left">
            <div className="flex flex-col gap-6">
              <div className="w-20 h-20 flex items-center justify-center">
                <img src={smile} alt="" className="w-20 h-20 object-contain" />
              </div>
              <h2 className="text-[48px] leading-[1.1] font-['Times_New_Roman'] text-black text-balance break-words">
                {t('footer.seeYouNext')}
              </h2>
            </div>

            <div className="flex flex-col gap-4 text-sm md:text-base text-black">
              <a href="mailto:newbusiness@live.tt" className="underline">
                newbusiness@live.tt
              </a>

              <div className="space-y-1">
                <p>{t('footer.findUs')}</p>
                <p className="space-x-1">
                  <a
                    href="https://www.instagram.com/live.tt"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline"
                  >
                    Instagram,
                  </a>
                  <a
                    href="https://www.linkedin.com/company/live-tt"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline"
                  >
                    {' '}
                    Linkedin,
                  </a>
                  <a
                    href="https://www.facebook.com/live.tt"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline"
                  >
                    {' '}
                    Facebook,
                  </a>
                  <a href="mailto:hello@live.tt" className="underline">
                    {' '}
                    hello@live.tt
                  </a>
                </p>
              </div>

              <div className="pt-4">
                <p className="font-['Times_New_Roman'] text-[20px] leading-tight">
                  <span className="italic">live.</span>{' '}
                  <span>Culture-Driven</span>
                  <br />
                  <span>Creative Powerhouse</span>
                </p>
              </div>

              <div className="pt-6 border-t border-black/20">
                <ComplianceLinks
                  className="sm:justify-between w-full"
                  linkClassName="text-sm md:text-base text-black"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

